"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELocales = void 0;
/**
 * @deprecated use string instead
 * @EN (English)
 * @ES (Spanish)
 * @PTBR Brazil (Portuguese)
 */
var ELocales;
(function (ELocales) {
    ELocales["PTBR"] = "pt-BR";
    ELocales["EN"] = "en";
    ELocales["ES"] = "es";
})(ELocales || (exports.ELocales = ELocales = {}));
//# sourceMappingURL=locale.js.map